
export const videoLinks = [
    "https://youtu.be/FrMjtWo4zm8?si=gNhJnNTEnoqDoVfx",
    "https://youtu.be/TZpvskO6efk?si=Xjb2u-BNOGAmkqsh",
    "https://youtu.be/2eWbW8N5vkM?si=3shnCaN2bOTJ2lYa",
    "https://youtu.be/pmsvzWXtnkA?si=b5k8ljBTdhaMmgcV",
    "https://youtu.be/LkW-tiLht1s?si=FjuR3w6ng-w921u7",
    "https://youtu.be/XOX-a_EMKjc?si=gd8HSIOaa015__rb",
    "https://youtu.be/CovYg5S5Yx0?si=1dAS4JQxAuMKPh3c",
    "https://youtu.be/yJ81xeuLdsI?si=0Xonu9R1anVkYmsu",
    "https://youtu.be/iuo_VcOMSYk?si=nzDvlXCyJcnYJq3K",
    "https://youtu.be/_x42HhiwF-g?si=I3ggPng8uZ_a9cZb",
];

export const audioLinks = [
    "https://youtu.be/vSJ-DCsJjeU?si=c-CVTUFtsdFWUg4T",
    "https://youtu.be/SkY6lrFY7OM?si=G5mHF6b2qdG6CbkJ",
    "https://youtu.be/qMCT_Ntzxjs?si=ccXZtMclITvKAbRh",
    "https://youtu.be/FzUA6LyOjfQ?si=bZEDr1A09gnEihe7",
    "https://youtu.be/1RytHbtA1Bg?si=O4MvcUrxz335xWd4",
    "https://youtu.be/s3KudFIEUbk?si=c1DbOxsTMZbBmk1M",
    "https://youtu.be/LfJMOELeYpM?si=2euEYIYWyA4zraBB",
    "https://youtu.be/XXUJSb6Dzjo?si=B-kttDTxgHzYCVa1",
    "https://youtu.be/P7vqoerVcag?si=WMQo_2xNd7DLIkzC",
    "https://youtu.be/P7vqoerVcag?si=w1hYO3tjL6u_yn6e",
    "https://youtu.be/xMhTWp0iM8o?si=K3r_Wf36c3jJCPqH",
    "https://youtu.be/mLsv-CD4Rdo?si=Av_JEqr7JrkqeOng",
];

export const bibleStudy_Links = [
    'https://www.youtube.com/live/4egjXS3XDHU?si=4soPbfv_6G__7uRO',
    'https://www.youtube.com/live/EBo4Y7YB1qc?si=MB4yvPXJyfuuRioE',
    'https://www.youtube.com/live/d2VJadoWKV4?si=29rpBDSHq-OWoYkG'
  ]